module.exports = __webpack_public_path__ + "img/security-system.c61a4eb9.png";